import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-unit-form',
    templateUrl: './unit-form.component.html',
    styleUrls: ['./unit-form.component.less'],
    standalone: false
})
export class UnitFormComponent implements OnInit {

  unitForm: FormGroup;
  editPermission : boolean = false;
  isEditedData:boolean=false;

  constructor(private formBuilder: FormBuilder, 
              @Inject(MAT_DIALOG_DATA) public data: any,
              private service:DataService,
              private utilityService: UtilityService, private permissionService:PermissionService,
              private dailogRef : MatDialogRef<UnitFormComponent>,
              private router :Router, private dailog:MatDialog,) { }

  ngOnInit(): void {
    this.initializeForm();
    this.patchValue();
  }

  private initializeForm(){
		this.unitForm = this.formBuilder.group({
      id:[],
      name:[null,[Validators.required]],
      code:[null,[Validators.required]]
		});
 	}

  private patchValue() {
    if (this.data?.id) {
      this.unitForm.patchValue(this.data);
    }
  }

  save(){
    this.unitForm.markAllAsTouched();
    if(this.unitForm.valid)
    {
      this.isEditedData=true;
        if(this.id.value){
          this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
        }
        else {
          this.openDailog(Message.SAVE_OPEN_DAILOG);
        }  
    }
  }

  public saveUnit() {  
    this.unitForm.markAllAsTouched();
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.unitForm.valid){
       this.service[method](Api.UNIT, this.unitForm.value).subscribe(res => {
         this.utilityService.notifier('Unit Details '+message +' successfully', 'success');
         this.router.navigate([APP_ROUTES.UNIT]);
         this.dailogRef.close();
        });
     }
  }

  public cancel() 
  {
    if(this.unitForm.dirty){
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
      this.router.navigate([APP_ROUTES.UNIT]);
      this.dailogRef.close();
    }
 
  }

  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });
  
    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
          else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.UNIT]);
            this.dailogRef.close();
          } 
          else{
            this.saveUnit();
          }
        }
    })
  }

  public checkAllPermission(){
    let permissionCodes=[PermissionKey.UNIT_MODULE_EDIT_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.UNIT_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.UNIT_MODULE_EDIT_PERMISSION})?.show?true:false; 
  }

  get id(){return this.unitForm.get('id')};
  get name(){return this.unitForm.get('name')};
  get code(){return this.unitForm.get('code')};
}
